export default __webpack_public_path__ + "static/media/img_16.41815c63.jpg";